import UserRepository from "../../ports/userRepository";
import { UserType } from "../../../entities/user";
import { Query } from "../../../entities/query";

export type fetchUsersUsecase = (
  query: Query,
) => Promise<{
  data?: UserType[];
  lastElement?: unknown;
  firstElement?: unknown;
}>;

export const buildFetchUsers = (dependencies: {
  userRepo: UserRepository;
}): fetchUsersUsecase => {
  const { userRepo } = dependencies;

  const fetchUsers = async (
    query: Query,
  ) => userRepo.fetchUsers(query);

  return fetchUsers;
};
